import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { ProviderPJContextService } from '../../shared/services/provider-pj-context.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-provider-pj',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './provider-pj.component.html'
})
export class ProviderPJComponent implements OnInit, OnDestroy {
  providerId: string | null = null;
  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private providerContext: ProviderPJContextService
  ) {}

  ngOnInit(): void {
    // Monitora mudanças de parâmetros na rota
    const paramSub = this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id && id !== this.providerId) {
        this.providerId = id;
      }
    });

    this.subscriptions.push(paramSub);

    // Define o ID inicial
    this.providerId = this.route.snapshot.paramMap.get('id');
    if (this.providerId) {
      this.providerContext.setProviderId(this.providerId);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
